import { mulColor } from './boss-tier';

/**
 * Boss body read-outs (docs/02 art note): damage stages, the charge wind-up
 * and the aimed-volley body cue (X13). Pure colour math — Boss.render applies it.
 */
export const LOOK = {
  /** Aimed volley winding up: the body swells and glows */
  warnTint: 0xffb07a,
  warnSwell: 1.07,
  /** Charge-movement wind-up */
  chargeTint: 0xff7766,
  /** Damage stages: hp above `pct` keeps the stage tint */
  stages: [
    { pct: 0.66, tint: 0xffffff },
    { pct: 0.33, tint: 0xf2c4b4 },
    { pct: 0, tint: 0xe89a8a },
  ],
  /** Crack overlay texture is authored for this body diameter (px) */
  crackSize: 180,
  ringSpin: 0.012,
  /** Orbit ring (Sentinel) whirls this much faster while a volley loads */
  warnRingSpin: 7,
  /** Hit flash duration (s) — drives the body punch */
  hitFlash: 0.08,
} as const;

/** Body tint: charge wind-up > volley cue > damage stage × tier tint. */
export function bodyTint(pct: number, levelTint: number, windup: boolean, warn: boolean): number {
  if (windup) return LOOK.chargeTint;
  if (warn) return LOOK.warnTint;
  const stage = LOOK.stages.find((s) => pct > s.pct) ?? LOOK.stages[LOOK.stages.length - 1]!;
  return mulColor(stage.tint, levelTint);
}

/** Crack overlay frame for the hp ratio — null while the hull is intact. */
export function crackFrame(pct: number): number | null {
  if (pct > LOOK.stages[0].pct) return null;
  return pct > LOOK.stages[1].pct ? 0 : 1;
}

/** Channel-wise blend a → b by t (0..1) — heat glows, phase flickers. */
export function lerpColor(a: number, b: number, t: number): number {
  const ch = (sh: number) => {
    const x = (a >> sh) & 0xff;
    return Math.round(x + (((b >> sh) & 0xff) - x) * t) << sh;
  };
  return ch(16) | ch(8) | ch(0);
}
